import React from 'react';
import inflection from 'inflection';

import ActionsAccepted from 'buyside/components/presentation/UserAccount/ViewerIntroRequests/Actions/viewerIntroRequestActionsAccepted';
import ActionsPending from 'buyside/components/presentation/UserAccount/ViewerIntroRequests/Actions/viewerIntroRequestActionsPending';
import Link from 'buyside/components/presentation/Link/link';

import { ideaUrl, userUrl } from 'buyside/util/urlHelper';
const { viewerIntroRequestStatuses } = require('buyside/util/constantsFromRails.json');

import styles from './styles.scss';

const UserViewerIntroRequestRow: React.FC<{
  authorId: string;
  authorDisplayName: string;
  currentUserId: string;
  dateReceived: string;
  id: string;
  status: string;
  viewableDisplayTitle: string;
  viewableId: string;
}> = ({
  authorDisplayName,
  authorId,
  currentUserId,
  dateReceived,
  id,
  status,
  viewableDisplayTitle,
  viewableId
}) => {
  const pending = status === viewerIntroRequestStatuses.pending;

  return (
    <tr className={styles.container}>
      <td>{dateReceived}</td>

      <td className={pending ? styles.pending : styles.accepted}>
        {inflection.capitalize(status)}
      </td>

      <td>
        <Link to={userUrl(authorId)}>{authorDisplayName}</Link>
      </td>

      <td>
        <Link to={ideaUrl(viewableId)}> {viewableDisplayTitle}</Link>
      </td>

      <td className={styles.actions}>
        {pending ? (
          <ActionsPending id={id} currentUserId={currentUserId} />
        ) : (
          <ActionsAccepted id={id} authorDisplayName={authorDisplayName} authorId={authorId} />
        )}
      </td>
    </tr>
  );
};

export default UserViewerIntroRequestRow;
